/**
 * Artifact types: reports and content produced by an agent, shown in a stream.
 * Individually addressable within a workspace with a permalink.
 */

import { z } from 'zod';

export const ArtifactMetaSchema = z.object({
  artifactId: z.string(),
  workspaceId: z.string(),
  /** Slug for permalink: /workspaces/:wid/artifacts/:slug */
  permalinkSlug: z.string(),
  title: z.string(),
  /** e.g. summary_report, build_log */
  type: z.string().default('report'),
  /** Optional session that produced this artifact */
  sessionId: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ArtifactMeta = z.infer<typeof ArtifactMetaSchema>;
